import LayoutWrapper from "../components/LayoutWrapper";
import HeaderBar from "../components/HeaderBar";
import { useState, useContext, useEffect } from "react";
import getCurrentSkin from "../utils/getCurrentSkin";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { ThemeContext } from "../context/ThemeContext";
import axios from "axios";
import * as XLSX from "xlsx";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ItemInnerSubCategoryMas from "./ItemInnerSubCategoryMas"; // adjust path if needed
import ConfirmModal from "../components/ConfirmModal";


const ItemInnerSubCategoryMaster = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isDark, skin, setSkin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin);
  const { baseColor, baseShade } = currentSkin;

  const parentCategory = location.state?.parentCategory;

  const parentCategoryCode =
    parentCategory?.fld_itemCategoryCode || parentCategory?.fld_itemcategoryCode || "";

  const [showAddForm, setShowAddForm] = useState(false);
  const [innerSubCategories, setInnerSubCategories] = useState([]);
  const [editInnerSubCategory, setEditInnerSubCategory] = useState(null);
  const [search, setSearch] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
const [loading, setLoading] = useState(true);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);


  const buttonClass = `bg-${baseColor}-${baseShade}`;
  const hoverClass = `hover:bg-${baseColor}-700`;

  const finYearId = localStorage.getItem("finYearId") || "";
  const finYear = localStorage.getItem("finYear") || "";
  const branchId = localStorage.getItem("branchId") || "";
  const branch = localStorage.getItem("branchType") || "";
  const userId = localStorage.getItem("userId") || "";

  const commonHeaders = {
    "x-finyearid": finYearId,
    "x-finyear": finYear,
    "x-branchid": branchId,
    "x-branch": branch,
    "x-userid": userId,
  };

  useEffect(() => {
    if (!parentCategory) {
      navigate("/", { replace: true });
    }
  }, [parentCategory, navigate]);

  const fetchData = async () => {
    if (!parentCategory?.fld_itemsubCategoryid) return;

    setLoading(true);
    try {
      const res = await axios.get("https://nissi-india.com/api/itemInnerSubCategoryList", {
        params: {
          subCategoryId: parentCategory.fld_itemsubCategoryid,
          search: search.trim(),
          page,
          pageSize: limit,
        },
        headers: commonHeaders,
      });

      setInnerSubCategories(res.data.innerSubCategories || []);
      setTotalCount(res.data.totalCount || 0);
      setTotalPages(Math.ceil((res.data.totalCount || 0) / limit) || 1);
    } catch (error) {
      console.error("Error fetching:", error);
      setInnerSubCategories([]);
      setTotalCount(0);
      setTotalPages(1);
      toast.error("Failed to fetch inner subcategories.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [parentCategory, page, search]);

const handleDeleteSelected = () => {
    if (selectedItems.length === 0) return;
    setShowDeleteConfirm(true);
  };

  const confirmDeleteSelected = async () => {
    setShowDeleteConfirm(false);
    try {
      for (const item of selectedItems) {
        const id = item.fld_innersubCategoryid;
        if (!id) continue;
        await axios.delete(`https://nissi-india.com/api/innerSubCategory_delete/${id}`, {
          headers: commonHeaders,
        });
      }
      setSelectedItems([]);
      fetchData();
      toast.success("Selected items removed successfully!");
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Error removing items.");
    }
  };

  if (!parentCategory) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-lg text-gray-500">Redirecting...</p>
        </div>
      </div>
    );
  }

  return (
    <LayoutWrapper>
      <HeaderBar
        title={<span className="font-dmserif text-3xl">Inner Sub Category</span>}
        setSkin={setSkin}
        currentSkin={skin}
      />

      <div
        className={`font-roboto-slab p-6 rounded-2xl shadow-xl border mt-6 ${
          isDark
            ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-white"
            : `bg-gray-200 ${currentSkin.glass} text-black`
        }`}
      >
        {/* Top Bar */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-4 gap-4">
          <div>
            <h2 className="text-xl font-semibold">
              Parent:{" "}
              <span className="text-blue-600">
                {parentCategoryCode} → {parentCategory.fld_itemsubCategoryCode} (
                {parentCategory.fld_itemsubCategoryName})
              </span>
            </h2>
          </div>

          <div className="flex flex-col sm:flex-row items-stretch gap-3 w-full sm:w-auto">
            <input
              type="text"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
              placeholder="Search Inner Sub Categories..."
              className={`px-4 py-2 rounded-lg text-sm placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-400 ${
                isDark
                  ? "bg-gray-800/30 text-gray-200 border-white/20"
                  : "bg-white text-black border-gray-300"
              }`}
            />

            <button
              onClick={() => {
                setEditInnerSubCategory(null);
                setShowAddForm(true);
              }}
              className={`px-4 py-2 text-white text-sm rounded-lg shadow transition ${buttonClass} ${hoverClass}`}
            >
              + Add New
            </button>
          </div>
        </div>

     

        {/* Table */}
        <div className="overflow-x-auto">
          <table
            className={`w-full text-sm text-left border border-gray-300 rounded-xl overflow-hidden font-roboto-slab ${
              isDark ? "text-gray-200 bg-white/10" : "text-black bg-white"
            }`}
          >
            <thead className={`text-xs uppercase text-white bg-${baseColor}-${baseShade} shadow-sm`}>
              <tr>
                <th className="px-4 py-3 border-b border-gray-300">S.No</th>
                <th className="px-4 py-3 border-b border-gray-300">Code & Name</th>
                <th className="px-4 py-3 border-b border-gray-300">Remarks</th>
                <th className="px-4 py-3 border-b border-gray-300">Add Deep</th>
                <th className="px-4 py-3 border-b border-gray-300">Edit</th>
                <th className="px-4 py-3 border-b border-gray-300">Select</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-300">
              {loading ? (
                [...Array(limit)].map((_, idx) => (
                  <tr key={idx}>
                    {[...Array(6)].map((_, cell) => (
                      <td key={cell} className="px-4 py-3 border-b border-gray-200">
                        <Skeleton height={20} />
                      </td>
                    ))}
                  </tr>
                ))
              ) : innerSubCategories.length === 0 ? (
                <tr>
                  <td colSpan={6} className="text-center py-6 text-gray-500">
                    No inner sub categories found.
                  </td>
                </tr>
              ) : (
                innerSubCategories.map((item, idx) => (
                  <tr
                    key={item.fld_innersubCategoryid || idx}
                    className={`${!isDark ? "hover:bg-gray-50" : "hover:bg-white/5"} transition`}
                  >
                    <td className="px-4 py-3 border-b border-gray-200">
                      {(page - 1) * limit + idx + 1}
                    </td>
                    <td className="px-4 py-3 border-b border-gray-200 font-medium">
                      {item.fld_innersubCategoryCode} ({item.fld_innersubCategoryName})
                    </td>
                    <td className="px-4 py-3 border-b border-gray-200">
                      {item.fld_remarks || "-"}
                    </td>
                    <td className="px-4 py-3 border-b border-gray-200">
                      <button
                        className="text-blue-600 hover:underline"
                        onClick={() =>
                          navigate("/inventory/ItemDeepInnerSubCategoryMaster", {
                            state: {
                              parentCategory: {
                                fld_itemcategoryid: parentCategory.fld_itemcategoryid,
                                fld_itemCategoryCode: parentCategoryCode,
                                fld_itemsubCategoryid: parentCategory.fld_itemsubCategoryid,
                                fld_itemsubCategoryCode: parentCategory.fld_itemsubCategoryCode,
                                fld_itemsubCategoryName: parentCategory.fld_itemsubCategoryName,
                                fld_innersubCategoryid: item.fld_innersubCategoryid,
                                fld_innersubCategoryCode: item.fld_innersubCategoryCode,
                                fld_innersubCategoryName: item.fld_innersubCategoryName,
                              },
                            },
                          })
                        }
                      >
                        Add Deep
                      </button>
                    </td>
                    <td className="px-4 py-3 border-b border-gray-200">
                      <button
                        className="text-yellow-500 hover:text-yellow-600"
                        onClick={() => {
                          setEditInnerSubCategory(item);
                          setShowAddForm(true);
                        }}
                      >
                        ✏️
                      </button>
                    </td>
                    <td className="px-4 py-3 border-b border-gray-200 text-center">
                      <input
                        type="checkbox"
                        checked={selectedItems.some(
                          (s) => s.fld_innersubCategoryid === item.fld_innersubCategoryid
                        )}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedItems((prev) => [...prev, item]);
                          } else {
                            setSelectedItems((prev) =>
                              prev.filter(
                                (s) => s.fld_innersubCategoryid !== item.fld_innersubCategoryid
                              )
                            );
                          }
                        }}
                        className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-400"
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {/* Action Buttons */}
          <div className="flex justify-end mt-4 space-x-4">
            <button
              disabled={selectedItems.length === 0}
              onClick={handleDeleteSelected}
              className={`px-4 py-2 text-white text-sm rounded-lg shadow transition ${buttonClass} ${hoverClass} ${
                selectedItems.length === 0 ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              🗑 Remove
            </button>

            <button
              onClick={() => {
                if (innerSubCategories.length === 0) {
                  toast.info("No data available to export.");
                  return;
                }
                const wsData = [
                  ["S.No", "Code", "Name", "Remarks"],
                  ...innerSubCategories.map((item, idx) => [
                    idx + 1,
                    item.fld_innersubCategoryCode,
                    item.fld_innersubCategoryName,
                    item.fld_remarks || "-",
                  ]),
                ];
                const ws = XLSX.utils.aoa_to_sheet(wsData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "InnerSubCategories");
                XLSX.writeFile(wb, "InnerSubCategories.xlsx");
                toast.success("Exported to Excel!");
              }}
              className="flex items-center gap-2 px-4 py-2 text-white text-sm rounded-lg shadow transition bg-green-600 hover:bg-green-700"
            >
              📥 Export Excel
            </button>
          </div>
        </div>

        {/* Pagination */}
        <div className="flex flex-col md:flex-row items-center justify-between mt-6 gap-4">
          <div className={`text-sm ${isDark ? "text-gray-300" : "text-gray-700"}`}>
            Showing{" "}
            <span className="font-semibold">
              {totalCount === 0 ? 0 : (page - 1) * limit + 1}
            </span>{" "}
            to{" "}
            <span className="font-semibold">{Math.min(page * limit, totalCount)}</span> of{" "}
            <span className="font-semibold">{totalCount}</span> results
          </div>

          {loading ? (
            <div className="flex space-x-2">
              <Skeleton width={80} height={36} borderRadius={12} />
              <Skeleton width={32} height={36} borderRadius={12} />
              <Skeleton width={32} height={36} borderRadius={12} />
              <Skeleton width={80} height={36} borderRadius={12} />
            </div>
          ) : (
            <div className="inline-flex rounded-lg shadow-sm overflow-hidden border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 font-sans">
              <button
                onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                disabled={page === 1}
                className={`px-4 py-2 text-sm font-medium ${
                  page === 1
                    ? "text-gray-400 cursor-not-allowed"
                    : "hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-200"
                }`}
              >
                Prev
              </button>

              {[...Array(totalPages)].map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setPage(idx + 1)}
                  className={`px-4 py-2 text-sm font-medium transition ${
                    page === idx + 1
                      ? `bg-${baseColor}-${baseShade} text-white`
                      : `hover:bg-${baseColor}-100 text-gray-700 dark:hover:bg-${baseColor}-800 dark:text-gray-200`
                  }`}
                >
                  {idx + 1}
                </button>
              ))}

              <button
                onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={page === totalPages}
                className={`px-4 py-2 text-sm font-medium ${
                  page === totalPages
                    ? "text-gray-400 cursor-not-allowed"
                    : "hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-200"
                }`}
              >
                Next
              </button>
            </div>
          )}
        </div>

<ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          closeOnClick
          pauseOnHover
          theme={isDark ? "dark" : "light"}
          style={{ top: "90px", zIndex: 99999 }}
        />
      </div>

{showAddForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
          <div className="w-full max-w-2xl max-h-[90vh] overflow-y-auto rounded-2xl">
            <ItemInnerSubCategoryMas
              editData={editInnerSubCategory}
              parentCategory={parentCategory}
              onSuccess={() => {
                toast.success(
                  editInnerSubCategory
                    ? "Inner subcategory updated successfully!"
                    : "Inner subcategory added successfully!"
                );
                setShowAddForm(false);
                setEditInnerSubCategory(null);
                fetchData();
              }}
              onCancel={() => {
                setShowAddForm(false);
                setEditInnerSubCategory(null);
              }}
            />
          </div>
        </div>
      )}

      <ConfirmModal
        open={showDeleteConfirm}
        title="Remove Inner Subcategories"
        message={`Are you sure you want to remove ${selectedItems.length} inner subcategory(ies)? This action cannot be undone.`}
        confirmLabel="Remove"
        onConfirm={confirmDeleteSelected}
        onCancel={() => setShowDeleteConfirm(false)}
      />
    </LayoutWrapper>
  );
};

export default ItemInnerSubCategoryMaster;